<template>
  <section class="ma-4 ma-md-8">
    <t-page-title title="Banners | Criar" />
    <v-row justify="center" align="center">
      <v-col>
        <v-card class="pa-8">
          <form-banner :banner="banner" @submit="submit" />
        </v-card>
      </v-col>
    </v-row>
  </section>
</template>

<script lang="ts" setup>
import FormBanner from './form-banner.vue'
import TPageTitle from '@/components/TPageTitle.vue'
import BannerService from '@/services/BannerService'
import { Banner } from '@/types/Banner'
import { useLoader } from '@/stores/loader'
import { useSnackBar } from '@/stores/snackbar'
import { useRouter } from 'vue-router'
import { AxiosError } from 'axios'
import { DateTime } from 'luxon'

const now = DateTime.now()
const banner: Banner = {
  status: 'active',
  category: 'external',
  description: '',
  publish_at: now.toFormat('yyyy-MM-dd HH:mm:ss'),
  unpublish_at: now.set({ hour: 23, minute: 59, second: 59 }).toFormat('yyyy-MM-dd HH:mm:ss'),
} as Banner
const loader = useLoader()
const snackbar = useSnackBar()
const router = useRouter()

async function submit(model: Banner, image?: File) {
  try {
    loader.increment()
    await (new BannerService()).store(model, image)

    snackbar.show(
      'Banner cadastrado com sucesso',
      'success',
    )

    router.push({ name: 'list-banners' })
  } catch (error) {
    if (error instanceof AxiosError) {
      snackbar.show(error.response?.data?.message, 'error')
    } else if (error instanceof Error) {
      snackbar.show(error.message, 'error')
    } else {
      snackbar.show('Não foi possível atualizar as informações do banner', 'error')
    }
  } finally {
    loader.decrement()
  }
}

</script>
